import { useIonAlert } from "@ionic/react";
import { useEffect, useRef } from "react";
import { useCustomerAddressesStateData } from "../providers/CustomerAddresses/CustomerAddressesStateContext";
import { useCustomerAddressesStorageData } from "../providers/customerAddressesStorage";
import { useConfig } from "../providers/config";
import { useAuth } from "../contexts/auth-context";
import { useGetCustomerAddresses } from "../providers/CustomerAddresses";
import { useCustomerAddressesStorageState } from "../providers/customerAddressesStorage/useCustomerAddressesStorage";
import { useTranslation } from "react-i18next";

const useAddFirstAddress = () => {
  const { t } = useTranslation();
  const [presentAlert] = useIonAlert();
  const { isCustomerAdressesEnabled, isNecessaryToCreateAddress } = useConfig();
  const { setIsAddressModalOpen, isAddressModalOpen } = useCustomerAddressesStateData();
  const { setCurrentShippingAddressId, unAuthedCustomerAddresses } = useCustomerAddressesStorageData();
  const currentShippingAddressId = useCustomerAddressesStorageState.getState().currentShippingAddressId;

  const isFirstRender = useRef(true);

  const { user } = useAuth();
  const { data: customerAddresses } = useGetCustomerAddresses({
    customerId: user?.id,
    options: {
      enabled: !!user?.id,
    },
  });

  useEffect(() => {
    const isFirstAddressBeingAdded =
      isCustomerAdressesEnabled &&
      isNecessaryToCreateAddress &&
      !isFirstRender.current &&
      !currentShippingAddressId &&
      !isAddressModalOpen;

    if (isFirstAddressBeingAdded) {
      presentAlert({
        header: t("Delivery address"),
        message: t("Choose a delivery address to see current products and shares"),
        backdropDismiss: false,
        keyboardClose: false,
        buttons: [
          {
            text: t("Continue"),
            handler: () => {
              console.log("handler TRUE");
              setIsAddressModalOpen(true);
            },
          },
        ],
      });
    }
  }, [isAddressModalOpen, currentShippingAddressId]);

  useEffect(() => {
    const addresses = user?.id ? customerAddresses : unAuthedCustomerAddresses;

    if (isNecessaryToCreateAddress && isCustomerAdressesEnabled && !currentShippingAddressId) {
      if ((addresses ?? []).length > 0) {
        setCurrentShippingAddressId(addresses![0].id!, "useAddFirstAddress");
      } else {
        setIsAddressModalOpen(true);
        isFirstRender.current = false;
      }
    }
  }, [user?.id, currentShippingAddressId, customerAddresses]);
};

export default useAddFirstAddress;
